<template>
  <div class="list">
    <div
      class="list-item"
      v-for="item in videoList"
      :key="item.id"
      @click="callMarketByPkg">
      <div class="item-image">
        <div
          class="image"
          :style="{ backgroundImage: 'url(' + item.videos[0].image + ')'}"/>
        <div class="go-app">打开APP</div>
      </div>
      <div class="item-title">
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    videoList: {
      type: Array,
      default: function() {
        return []
      }
    }
  },

  methods: {
    callMarketByPkg() {
      this.$emit('callMarketByPkg');
    }
  }
};
</script>

<style lang='scss' scoped>
.list {
  width: px2rem(1040);
  margin: px2rem(40) auto;
}
.list-item {
  width: px2rem(510);
  display: inline-block;
}
.list-item:nth-child(2n + 1) {
  margin-right: px2rem(20);
}
.item-image {
  position: relative;
}
.image {
  width: px2rem(510);
  height: px2rem(340);
  margin-bottom: px2rem(10);
  border-radius: px2rem(20);
  position: relative;
  overflow: hidden;

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}
.go-app {
  width: px2rem(200);
  height: px2rem(64);
  background: #fb3458;
  line-height: px2rem(66);
  text-align: center;
  font-size: px2rem(36);
  color: #fff;
  position: absolute;
  bottom: px2rem(24);
  left: px2rem(18);
  border-radius: px2rem(15);
}
.item-title {
  font-size: px2rem(36);
  line-height: px2rem(50);
  font-weight: 700;
  margin-bottom: px2rem(50);
  margin-top: px2rem(10);
  padding: 0 px2rem(10);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  height: px2rem(100);
}
</style>
